import PropTypes from "prop-types";
import React from "react";
import SVG from "theme/components/icons/base/SVG";
import styled from "theme/libs/styled";

const directions = {
    down: "90deg",
    left: "180deg",
    up: "270deg",
    right: "360deg",
};

const StyledSVG = styled(SVG)`
    transform: rotate(${({ rotate }) => rotate});
`;

const ChevronIcon = ({ width, height, viewBox, color, direction, ...props }) => (
    <StyledSVG
        width={width}
        height={height}
        viewBox={viewBox}
        rotate={directions[direction]}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="m4 10.5 4-4-4-4" stroke={color} />
    </StyledSVG>
);

ChevronIcon.propTypes = {
    color: PropTypes.string,
    direction: PropTypes.oneOf(["left", "right", "up", "down"]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

ChevronIcon.defaultProps = {
    color: "currentColor",
    direction: "right",
    height: "13px",
    viewBox: "0 0 12 13",
    width: "12px",
};

export default ChevronIcon;
